import type {
    ContentSelectionRequest,
    ContentSelectionResponse,
    Context,
    Filters,
} from "@amzn/g4sservice-client";
import { G4SClient as G4SSerivceClient } from "@amzn/g4sservice-client";
import { ContentSelectionCommand } from "@amzn/g4sservice-client";
import {
    APPENV,
    getCredentialsFromCacheOrCognito,
} from "@amzn/midway-cognito-type-script-provider";

import type { G4sPlacement } from "../../constants/g4sPlacement";
import { authStore } from "../../store/auth";
import { assumeInvocationRole } from "../credentials";

export class G4SClient {
    public client: G4SSerivceClient;
    public stage: string;
    constructor(client: G4SSerivceClient, stage: string) {
        this.client = client;
        this.stage = stage;
    }

    getContentSelection: (
        context?: Context,
        filters?: Filters,
        placement?: G4sPlacement,
    ) => Promise<ContentSelectionResponse> = async (
        context,
        filters,
        placement,
    ) => {
        const request: ContentSelectionRequest = {
            userAlias: authStore.getState().username,
            context,
            filters,
            placement,
        };
        return this.client.send(new ContentSelectionCommand(request));
    };
}

export async function getG4SClient(): Promise<G4SClient> {
    try {
        const {
            settings: {
                cognitoPoolId,
                region,
                g4sServiceEndpoint,
                stage,
                g4sServiceInvocationRoleArn,
            },
        } = authStore.getState();

        if (!g4sServiceEndpoint) {
            throw new Error("G4S endpoint not yet defined");
        }

        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentialsFromCacheOrCognito({
                region,
                identityPoolId: cognitoPoolId,
                clientId: window.location.host,
                redirectUri: window.location.href,
            });
        const assumeRoleCredentials = await assumeInvocationRole(
            region,
            accessKeyId,
            secretAccessKey,
            sessionToken!,
            g4sServiceInvocationRoleArn,
        );
        const client = new G4SSerivceClient({
            endpoint: `${APPENV.mock_server ? "http" : "https"}://${g4sServiceEndpoint}`,
            region,
            credentials: {
                accessKeyId: assumeRoleCredentials.AccessKeyId!,
                secretAccessKey: assumeRoleCredentials.SecretAccessKey!,
                sessionToken: assumeRoleCredentials.SessionToken,
            },
        });
        return new G4SClient(client, stage);
    } catch (e: any) {
        throw new Error(e.message);
    }
}
